module.exports = __webpack_public_path__ + "media/images/flags/mk-1373eb8769dd878d38ad61a50b8eb291.svg";